import React, { useState, useEffect } from "react";
import "../Invoices_Payments/Monthly.css";
import Base from "../admin_components/Admin_Base";
import { Breadcrumbs } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Link from "@mui/material/Link";
import { ADMIN_API_BASE_URL } from "../Auth/Api";
import authAxios from "../Auth/useAxios";
import { Button } from "@mui/material";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { ClipLoader } from "react-spinners";

const MonthlyScheduled = () => {
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [status, setStatus] = useState("All");
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 24;
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null)

  const years = Array.from({ length: 10 }, (_, i) => 2022 + i);
  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  useEffect(() => {
    fetchMonthlyPaymentList();
  }, []);

  const fetchMonthlyPaymentList = async () => {
    try {
      const response = await authAxios.get(`${ADMIN_API_BASE_URL}/main/admin/emis`);
      setPayments(response.data);
    } catch (error) {
      console.error("❌ Error fetching payments:", error);
    } finally {
      setLoading(false);
    }
  };

  // Filtering Logic
  const filteredData = payments.filter((request) => {
    const emiDate = new Date(request.emiDate);
    const emiYear = emiDate.getFullYear();
    const emiMonth = emiDate.toLocaleString("default", { month: "long" });

    const matchesYear = year ? emiYear === parseInt(year) : true;
    const matchesMonth = month ? emiMonth === month : true;
    const matchesStatus =
      status === "All" || (status === "Paid" && request.isPaid) || (status === "Unpaid" && !request.isPaid);
    const matchesSearch =
      search === "" ||
      request.customerName.toLowerCase().includes(search.toLowerCase()) ||
      request.groupName.toLowerCase().includes(search.toLowerCase()) ||
      request.passbook.toLowerCase().includes(search.toLowerCase()) ||
      request.mobile.toLowerCase().includes(search.toLowerCase());

    return matchesYear && matchesMonth && matchesStatus && matchesSearch;
  });

  // Handle CSV Download with all filtered data
  const handleDownload = () => {
    const headers = [
      "S.No",
      "Customer Name",
      "Property Name",
      "Passbook Number",
      "Phone Number",
      "EMI Year",
      "EMI Month",
      "Amount",
      "EMI Date",
      "EMI Paid Date",
      "Transaction ID",
      "Status",
    ];

    const rows = filteredData.map((row, index) => [
      index + 1,
      row.customerName,
      row.groupName,
      row.passbook,
      row.mobile,
      new Date(row.emiDate).getFullYear(),
      new Date(row.emiDate).toLocaleString("default", { month: "long" }),
      row.emiAmount,
      row.emiDate,
      row.emiPaidDate || "N/A",
      row.transactionId || "N/A",
      row.isPaid ? "Paid" : "Not Paid",
    ]);

    const csvContent = [headers, ...rows]
      .map((row) => row.map(item => `"${item}"`).join(","))  // Wrap items in quotes to handle commas in data
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;

    // Create filename based on filters
    let filename = "EMI_Data";
    if (year) filename += `_${year}`;
    if (month) filename += `_${month}`;
    if (status !== "All") filename += `_${status}`;
    filename += ".csv";

    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedRequests = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <Base>
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "300px" }}>
          <ClipLoader color="darkslategrey" size={50} />
        </div>
      ) : error ? (
        <div>{error}</div>
      ) : (
        <>
          <div className="container res_container">
            <div className="pt-3 mt-5 addarea_labels pr-3">
              <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                <Link underline="hover" href="/admin/dashboard" sx={{ color: "darkslategrey", fontWeight: "bold" }}>
                  Dashboard
                </Link>
                <Link underline="hover" href="/admin/Monthly_scheduled" sx={{ color: "darkslategrey", fontWeight: "bold" }}>
                  EMI Monthly Scheduled
                </Link>
              </Breadcrumbs>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <h2 className="fw-bold main_heading" >EMI Monthly Scheduled</h2>
              <Button className="csv_btn"
                // variant="contained" 
                // color="primary" 
                onClick={handleDownload}
                startIcon={<FileDownloadIcon />}
                // sx={{ backgroundColor: '#4caf50', '&:hover': { backgroundColor: '#998874' } }}
                disabled={filteredData.length === 0}
              >
                Export CSV
              </Button>
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <hr style={{ width: "90%" }} />
            </div>
            <div className="filters_monthly">
              <select className="filter_select" value={year} onChange={(e) => setYear(e.target.value)}>
                <option value="">All Years</option>
                {years.map((y) => (
                  <option key={y} value={y}>{y}</option>
                ))}
              </select>
              <select value={month} onChange={(e) => setMonth(e.target.value)}>
                <option value="">All Months</option>
                {months.map((m) => (
                  <option key={m} value={m}>{m}</option>
                ))}
              </select>
              <select value={status} onChange={(e) => setStatus(e.target.value)}>
                <option value="All">All Status</option>
                <option value="Paid">Paid</option>
                <option value="Unpaid">Unpaid</option>
              </select>
              <input
                type="text"
                placeholder="Search by Name, Property, Passbook, or Phone..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div className="table-container">
              <table className="customer table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Customer Name</th>
                    <th>Property Name</th>
                    <th>Passbook Number</th>
                    <th>Phone Number</th>
                    <th>EMI Year</th>
                    <th>EMI Month</th>
                    <th>Amount</th>
                    <th>EMI Date</th>
                    <th>EMI Paid Date</th>
                    <th>Transaction ID</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedRequests.length > 0 ? (
                    paginatedRequests.map((row, index) => {
                      const emiDate = new Date(row.emiDate);
                      return (
                        <tr key={row.id}>
                          <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                          <td>{row.customerName}</td>
                          <td>{row.groupName}</td>
                          <td>{row.passbook}</td>
                          <td>{row.mobile}</td>
                          <td>{emiDate.getFullYear()}</td>
                          <td>{emiDate.toLocaleString("default", { month: "long" })}</td>
                          <td>{Math.round(row.emiAmount)}</td>
                          <td>{row.emiDate}</td>
                          <td>{row.emiPaidDate || "N/A"}</td>
                          <td>{row.transactionId || "N/A"}</td>
                          <td>{row.isPaid ? "Paid" : "Not Paid"}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="12" className="text-center">No records found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {filteredData.length > 0 && (
              <div className="pagination-controls-payment-history">
                <button onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))} disabled={currentPage === 1}>
                  Previous
                </button>
                <span className="mx-2">Page {currentPage} of {totalPages}</span>
                <button onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}>
                  Next
                </button>
              </div>
            )}
          </div>
        </>
      )}
    </Base>
  );
};

export default MonthlyScheduled;